import React, { useContext } from "react";
import Tablecomp from "../comp/Table";
import { contextData } from "../Context";

const ContactList = () => {
  const { contactData } = useContext(contextData);

  const columnConfig = [
    {
      title: "id",
      dataIndex: "cid",
      key: "cid",
    },
    {
      title: "Full Name",
      dataIndex: "fullname",
      key: "fullname",
      isSearchable: true,
    },
    
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      isSearchable: true,
    },
    {
      title: "Contact",
      dataIndex: "contact",
      key: "contact",
      isSearchable: true,
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      isSearchable: true,
      render: (_, record) => (
        <div className="action_btn" style={{ display: "flex", gap: "10px" }}>
          <textarea disabled>{record.message}</textarea>
        </div>
      ),
    },
    {
      title: "Date & Time",
      dataIndex: "creationDate",
      key: "creationDate",
      isSearchable: true,
    },
  ];

  return (
    <>
      <Tablecomp columnConfig={columnConfig} tableData={contactData || []} />
    </>
  );
};

export default ContactList;
